import { render, staticRenderFns } from "./footBottom.vue?vue&type=template&id=bbd60e52&scoped=true"
import script from "./footBottom.vue?vue&type=script&lang=js"
export * from "./footBottom.vue?vue&type=script&lang=js"
import style0 from "./footBottom.vue?vue&type=style&index=0&id=bbd60e52&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd60e52",
  null
  
)

export default component.exports